import useAuth from '@/auth';

const auth = useAuth();

function checkRegisterStep({ to, next }) {
  const goingToRegisterSteps = to.name === 'register-steps';
  const goingToLogout = to.name === 'logout';

  const signupState = auth.user?.signupState;

  if (!signupState) return next();

  if (signupState === 'DONE' && goingToRegisterSteps) {
    return next({
      name: 'apps',
    });
  }

  if (signupState !== 'DONE' && !goingToRegisterSteps && !goingToLogout) {
    return next({
      name: 'register-steps',
    });
  }

  next();
}

export default function(to, from, next) {
  if (auth.ready) {
    return checkRegisterStep({ to, next });
  }

  auth.onReady(() => checkRegisterStep({ to, next }));
}
